import * as yup from 'yup';

import { StringTypeBase } from '../../baseTypes/StringTypeBase';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_TEXT } from '../constants';

const HTTP_URL_PREFIX = /^https?:\/\//i;

export const yupUrlSchema = yup
  .string()
  .test(
    'is-url',
    'The value must be a valid URL e.g. http://www.joinlane.com',
    value => {
      if (value === undefined || value === null) {
        return true;
      }

      try {
        const url = new URL(String(value).valueOf());

        return url && !url.protocol.includes('javascript');
      } catch {
        // FIXME: Log error for datadog, missing stack trace
        return false;
      }
    }
  )
  .nullable();

export const yupHttpUrlSchema = yup
  .string()
  .test(
    'is-http-url',
    'The value must be a valid URL e.g. http://www.joinlane.com',
    value => {
      if (value === undefined || value === null) {
        return true;
      }

      const text = String(value);

      if (!HTTP_URL_PREFIX.test(text)) {
        return false;
      }

      try {
        return Boolean(new URL(text));
      } catch {
        return false;
      }
    }
  )
  .nullable();

export class UrlType extends StringTypeBase {
  group = TYPE_GROUP_TEXT;

  name = 'Url';

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Data,
    TypeContextEnum.Properties,
  ];

  friendlyName = 'Website URL';

  restrictToHttpProtocols = false;

  get default(): any {
    return '';
  }

  buildSchema() {
    return this.restrictToHttpProtocols ? yupHttpUrlSchema : yupUrlSchema;
  }
}

const urlTypeDefinition = new UrlType();

Types.addBaseType(urlTypeDefinition);
export { urlTypeDefinition };
